import { Gear } from '@phosphor-icons/react'

import { getAssetLink } from '../../helpers/get-asset-link'
import { APP_COLORS } from '../../helpers/constants'

export const GROUP_POSTS_FILTERS = {
  POSTED: 'posted',
  SCHEDULED: 'scheduled',
}

export const toolbarTabOptions = [
  {
    id: 0,
    text: 'Posted',
    value: GROUP_POSTS_FILTERS.POSTED,
  },
  {
    id: 1,
    text: 'Scheduled',
    value: GROUP_POSTS_FILTERS.SCHEDULED,
  },
]

export const allGroupsOption = { id: -1, text: 'All Groups', value: -1 }

export const sortOptions = [
  { id: -1, text: 'Sort by', value: '' },
  { id: 0, text: 'A-Z', value: 'ASC' },
  { id: 1, text: 'Z-A', value: 'DESC' },
]

export const columns = ({ handleEdit = () => {} }) => {
  return [
    {
      Header: 'Group Name',

      Cell: ({ row: { original } }) => {
        return (
          <div className="groups-settings-table__cell">
            <img
              src={getAssetLink({ path: 'chitown-images/groups', file: original.image })}
              alt="group"
            />
            <div>{original.name}</div>
          </div>
        )
      },
    },
    {
      Header: 'Members',
      accessor: 'members',

      Cell: ({ value }) => {
        return `${value.count} members`
      },
    },
    {
      Header: 'Visible in App',
      accessor: 'active',

      Cell: ({ value }) => {
        return (
          <div className={`status-pill ${value ? 'active' : 'inactive'}`}>
            {value ? 'Yes' : 'No'}
          </div>
        )
      },
    },
    {
      id: 'settings',

      Cell: ({ row: { original } }) => {
        const handleEditGroup = () => {
          handleEdit(original.id)
        }
        return (
          <div className="groups-settings-table__cell end">
            <button className="button button-transparent" onClick={handleEditGroup}>
              <Gear size={20} fill={APP_COLORS.baseWhite} />
            </button>
          </div>
        )
      },
    },
  ]
}

export const neighbors = [
  { id: 1, name: 'John Doe', image: '/images/neighbor-1.png' },
  { id: 2, name: 'Jane Smith', image: '/images/neighbor-2.png' },
  { id: 3, name: 'Mike Johnson', image: '/images/neighbor-3.png' },
]
